import { render, staticRenderFns } from "./UserStatusButtons.vue?vue&type=template&id=45925954&scoped=true&"
import script from "./UserStatusButtons.vue?vue&type=script&lang=js&"
export * from "./UserStatusButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45925954",
  null
  
)

export default component.exports